import { PENDINGPOINT } from "./models/PENDINGPOINT";
import { Inject, Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { STAT } from "./models/STAT";
import { PROD } from "./models/PROD";
import { EMERG } from "./models/EMERG";
import { MSG } from "./models/MSG";
import { ACTIV } from "./models/ACTIV";
import { ALARM } from "./models/ALARM";
import { CONFIG } from "./models/CONFIG";
import { DB } from "./models/DB";
import { DEBUG } from "./models/DEBUG";
import { DEVCHANGE } from "./models/DEVCHANGE";
import { DEVSTAT } from "./models/DEVSTAT";
import { IDLE } from "./models/IDLE";
import { NETSTAT } from "./models/NETSTAT";
import { NOTIFYID } from "./models/NOTIFYID";
import { PRODSTATUS } from "./models/PRODSTATUS";
import { PLANNEDSTOP } from "./models/PLANNEDSTOP";
import { START } from "./models/START";
import { VPN } from "./models/VPN";
import { VPNSTAT } from "./models/VPNSTAT";
import {
  ArrayQueue,
  ConstantBackoff,
  RetryEventDetail,
  Websocket,
  WebsocketBuilder,
  WebsocketEvent,
} from "websocket-ts";
import { OEE } from "../e-connect-web-socket-local/lib/models";

@Injectable({
  providedIn: "root",
})
export class WebSocketService {
  public messageData: Subject<
    | STAT
    | PROD
    | EMERG
    | PRODSTATUS
    | MSG
    | DEVCHANGE
    | ACTIV
    | START
    | DB
    | NOTIFYID
    | CONFIG
    | DEVSTAT
    | NETSTAT
    | DEBUG
    | ALARM
    | VPN
    | VPNSTAT
    | PLANNEDSTOP
    | PENDINGPOINT
    | any
  > = new Subject();

  public retryConnection: boolean = true;
  public isRetryConnection: boolean = false;

  public recievedPong: Date;

  /*****/
  readonly CLOSED: number = 0;
  readonly CONNECTING: number = 1;
  readonly AUTHENTICATED: number = 2;
  /*****/
  public state: number = this.CLOSED;
  public connectionTimer;
  public pingConnectionTimer;

  public webSocket: Websocket | null;
  public countSend: number = 0;

  public accessToken: string | null = null;

  public readonly PROD_BIT: number = 0b0000000000000001;
  public readonly EMERG_BIT: number = 0b0000000000000010;
  public readonly IDLE_BIT: number = 0b0000000000000100;
  public readonly DEVCHANGE_BIT: number = 0b0000000000001000;
  public readonly STAT_BIT: number = 0b0000000000010000;

  public readonly ALL_BITS: number = 0b1111111111111111;

  constructor(@Inject("env") protected env: any) {}

  public setAccessToken(accessToken: string | null) {
    this.accessToken = accessToken;
  }

  public onConnect() {
    if (!this.accessToken) {
      return;
    }
    try {
      const self = this;
      self.retryConnection = true;
      self.webSocket = new WebsocketBuilder(self.env.webSocketURL)
        .onOpen((i, ev) => {
          self.onOpen(i, ev);
        })
        .onClose((i, ev) => {
          self.onClose(i, ev);
        })
        .onError((i, ev) => {
          self.onError(i, ev);
        })
        .onMessage((i, ev) => {
          self.onMessage(i, ev);
        })
        .onRetry((i, ev) => {
          self.onRetry(i, ev);
        })
        .onReconnect((i, ev) => {
          if (!self.retryConnection) {
            self.stopRetrying(i);
            return;
          }
          self.onOpen(i, ev);
        })
        .withBackoff(new ConstantBackoff(1000))
        .withBuffer(new ArrayQueue())
        .build();
    } catch (e) {
      // console.log(e);
    }
  }

  private onOpen(socketInstance: Websocket, event: Event): void {
    const self = this;

    self.recievedPong = new Date();
    if (self.accessToken) {
      self.Auth();
    }
    self.checkPing();
  }

  private onClose(socketInstance: Websocket, event: CloseEvent): void {
    const self = this;

    self.messageData.next("DISCONNECTED");
    clearInterval(self.pingConnectionTimer);
    self.pingConnectionTimer = null;
    self.state = self.CLOSED;
    self.isRetryConnection = false;
  }

  private onError(socketInstance: Websocket, event: Event): void {
    const self = this;
  }

  private onRetry(
    socketInstance: Websocket,
    event: CustomEvent<RetryEventDetail>
  ): void {
    const self = this;
    if (!self.retryConnection) {
      self.stopRetrying(socketInstance);
      return;
    }
    self.isRetryConnection = true;
  }

  public parseDate(dateFromSocket: string): Date {
    //20240521
    let dateString = `${dateFromSocket.substring(
      0,
      4
    )}-${dateFromSocket.substring(4, 6)}-${dateFromSocket.substring(6, 8)}`;
    return new Date(dateString);
  }

  public onMessage(socketInstance: Websocket, event: MessageEvent) {
    this.webSocket = socketInstance;
    this.recievedPong = new Date();
    const message = event.data;
    var data = JSON.parse(message);
    if (data.type == "AUTH") {
      this.state = this.AUTHENTICATED;

      var msg = new MSG();
      msg.Message = "OPEN";

      this.messageData.next(msg);
      /* Already doing it
      var activeDevices = window.sessionStorage.getItem("ActiveDevices");
      if (activeDevices != null) {
        var activeDevices2: string[] = JSON.parse(activeDevices);
        activeDevices2.forEach((element) => {
          this.Activ(element, true);
        });
      }

      var notifyChanges = window.sessionStorage.getItem("NOTIFYCHANGES");
      if (notifyChanges != null) {
        this.send(notifyChanges);
      }
      */
    } else if (data.type == "ACTIV") {
      var active = new ACTIV();

      active.SerialNumber = data.code;
      active.Active = data.active == 1;
      active.StatusPiece = data.statusPiece;

      this.messageData.next(active);
    } else if (data.type == "STAT") {
      var stat = new STAT();

      stat.SerialNumber = data.code;
      stat.Name = data.name;
      stat.Active = data.active == 1;
      stat.Latitude = data.latitude;
      stat.Longitude = data.longitude;
      stat.StatusPiece = data.statusPiece;

      this.messageData.next(stat);
    } else if (data.type == "START") {
      var start = new START();

      start.SerialNumber = data.serialNumber;
      start.StartDate = data.startDate;
      start.EndDate = data.endDate;
      start.Duration = data.duration;

      this.messageData.next(start);
    } else if (data.type == "OEE" || data.cmd == "OEE") {
      const oee = new OEE();
      oee.availability = data.Availability;
      oee.bestCadence = data.BestCadence;
      oee.cadence = data.Cadence;
      oee.count = data.Count;
      oee.counter1 = data.Counter1;
      oee.counter2 = data.Counter2;
      oee.cycleInfo = data.CycleInfo;
      oee.downtime = data.Downtime;
      oee.last24Hours = data.Last24Hours;
      oee.lastHour = data.LastHour;
      oee.lastMinute = data.LastMinute;
      oee.minutesElapsed = data.MinutesElapsed;
      oee.ngcount = data.NGCount;
      oee.OEE = data.OEE * 100;
      oee.OEELast7Days = data.OEELast7Days;
      oee.OEELast8Hours = data.OEELast8Hours;
      oee.operatingTime = data.OperatingTime;
      oee.performance = data.Performance;
      oee.quality = data.Quality;
      oee.reference = data.Reference;
      oee.cmd = data.cmd;
      oee.events = data.events;
      oee.pendingDowntimes = data.pendingDowntimes;
      oee.sn = data.sn;
      this.messageData.next(oee);
    } else if (data.type == "PROD") {
      var prod = new PROD();

      prod.SerialNumber = data.serialNumber;
      prod.DeviceId = data.deviceId;
      prod.ProdDataInici = data.prodDataInici;
      prod.ProdDataFi = data.prodDataFi;
      prod.StatusPiece = data.statusPiece;
      prod.TotalSteps = data.totalSteps;
      prod.TimeSinceLastPiece = data.timeSinceLastPiece;
      prod.Duration = data.duration;
      prod.Quantity = data.quantity;

      prod.TotalPiecesOK = data.totalPiecesOK;
      prod.TotalPiecesNG = data.totalPiecesNG;
      prod.DailyTotalPiecesOK = data.dailyTotalPiecesOK;
      prod.DailyTotalPiecesNG = data.dailyTotalPiecesNG;

      prod.DailyProduction = data.dailyProduction;

      prod.ReferenceProduction = data.referenceProduction;
      prod.ReferenceProductionNOK = data.referenceProductionNOK;

      prod.Oee = data.oee * 100;
      prod.Cadence = data.cadence;
      prod.ExpectedCadence = data.expectedCadence;

      let fiProdDate: Date = this.parseDate(data.prodDataFi);
      //Si la produccio no es d'avui no volem comptarla
      if (!isNaN(fiProdDate.getTime())) {
        let today: Date = new Date();
        let todayTime = today.setHours(0, 0, 0, 0);
        let fiProdTime = fiProdDate.setHours(0, 0, 0, 0);
        if (fiProdTime != todayTime) return;
      }

      this.messageData.next(prod);
    } else if (data.type == "EMERG") {
      var emerg = new EMERG();

      emerg.SerialNumber = data.serialNumber;
      emerg.Status = data.status == 1;
      emerg.StartDate = data.startDate;
      emerg.EndDate = data.endDate;
      emerg.Duration = data.duration;

      this.messageData.next(emerg);
    } else if (data.type == "IDLE") {
      var idle = new IDLE();

      idle.SerialNumber = data.serialNumber;
      idle.Status = data.status == 1;
      idle.StartDate = data.startDate;
      idle.EndDate = data.endDate;
      idle.Duration = data.duration;

      this.messageData.next(idle);
    } else if (data.type == "PRODSTATUS") {
      var prodStatus = new PRODSTATUS();

      prodStatus.Type = data.type;
      prodStatus.MachineId = data.machineId;
      prodStatus.DeviceId = data.deviceId;
      prodStatus.SerialNumber = data.serialNumber;
      prodStatus.ReferenceId = data.referenceId;
      prodStatus.ReferenceCode = data.referenceCode;
      prodStatus.ReferenceDescription = data.referenceDescription;
      prodStatus.StartDate = data.startDate;
      prodStatus.EndDate = data.endDate;
      prodStatus.Info = data.info;
      prodStatus.Of = data.of;
      prodStatus.PhaseId = data.phaseId;
      prodStatus.PhaseCode = data.phaseCode;
      prodStatus.PhaseDescription = data.phaseDescription;
      prodStatus.IsProduction = data.isProduction == 1;
      prodStatus.IsStart = data.isStart == 1;

      this.messageData.next(prodStatus);
    } else if (data.type == "PLANNEDSTOP") {
      var plannedStop = new PLANNEDSTOP();

      plannedStop.MachineId = data.machineId;
      plannedStop.StartDate = data.startDate;
      plannedStop.EndDate = data.endDate;
      plannedStop.SubtypeId = data.subtypeId;
      plannedStop.SubtypeDescription = data.subtypeDescription;

      this.messageData.next(plannedStop);
    } else if (data.type == "DEVCHANGE") {
      var devchange = new DEVCHANGE();

      devchange.SerialNumber = data.code;
      devchange.Name = data.name;
      devchange.StatusPiece = data.statusPiece;

      this.messageData.next(devchange);
    } else if (data.type == "DEBUG") {
      var debug = new DEBUG();

      debug.SerialNumber = data.serialNumber;
      debug.DeviceId = data.deviceId;
      debug.Date = data.date;
      debug.Message = data.message;

      this.messageData.next(debug);
    } else if (data.type == "ALARM") {
      var alarm = new ALARM();

      alarm.SerialNumber = data.serialNumber;
      alarm.Status = data.status;
      alarm.DeviceName = data.deviceName;
      alarm.Name = data.name;
      alarm.Description = data.description;
      alarm.AlarmConfId = data.alarmConfId;
      alarm.StartDate = data.startDate;
      alarm.EndDate = data.endDate;

      this.messageData.next(alarm);
    } else if (data.type == "DEVSTAT") {
      var devstat = new DEVSTAT();

      devstat.SerialNumber = data.serialNumber;
      devstat.Status = data.status;
      devstat.DeviceId = data.deviceId;
      devstat.Date = data.date;

      this.messageData.next(devstat);
    } else if (data.type == "NETSTAT") {
      var netstat = new NETSTAT();

      netstat.SerialNumber = data.serialNumber;
      netstat.NetData = JSON.parse(data.netData);
      netstat.Date = data.date;

      this.messageData.next(netstat);
    } else if (data.type == "DB") {
      var db = new DB();

      db.Data = data.data;

      this.messageData.next(db);
    } else if (data.type == "NOTIFYID") {
      var notifyid = new NOTIFYID();

      notifyid.HasChange = data.hasChange;

      this.messageData.next(notifyid);
    } else if (data.type == "CONFIG") {
      var config = new CONFIG();

      config.SerialNumber = data.serialNumber;
      config.Config = data.config;

      this.messageData.next(config);
    } else if (data.type == "VPN") {
      var vpn = new VPN();

      vpn.SerialNumber = data.serialNumber;
      vpn.Date = data.date;
      vpn.VPNName = data.vpnName;

      this.messageData.next(vpn);
    } else if (data.type == "VPNSTAT") {
      var vpnstat = new VPNSTAT();

      vpnstat.SerialNumber = data.serialNumber;
      vpnstat.Date = data.date;
      vpnstat.Status = data.status;
      vpnstat.VPNName = data.vpnName;

      this.messageData.next(vpnstat);
    } else if (data.type == "PENDINGPOINT") {
      var pendingpoint = new PENDINGPOINT();

      pendingpoint.registerId = data.registerId;
      pendingpoint.registerPointId = data.registerPointId;
      pendingpoint.auditPointId = data.auditPointId;
      pendingpoint.machineId = data.machineId;
      pendingpoint.workOrder = data.workOrder;

      this.messageData.next(pendingpoint);
    } else if (data.type == "PING") {
      this.send("PONG");
    } else if (data.type == "ERR") {
      this.messageData.next(data.msg);
    }
  }

  public send(
    message: string,
    saveMessage: boolean = true,
    callback = undefined
  ) {
    const self = this;
    if (
      this.webSocket &&
      this.webSocket.readyState == this.webSocket.underlyingWebsocket.OPEN
    ) {
      if (saveMessage && message.startsWith("NOTIFYCHANGES")) {
        var content = message.split(" ")[1];
        var parametres = content.split(";");

        var connection = parametres[0];
        var bits = parametres[1];

        if (bits == "")
          message = "NOTIFYCHANGES " + connection + ";" + this.ALL_BITS + ";";

        if (connection == "1")
          window.sessionStorage.setItem("NOTIFYCHANGES", message);
        else if (connection == "0")
          window.sessionStorage.removeItem("NOTIFYCHANGES");
      }
      self.webSocket?.send(message);
    }
  }

  public Auth() {
    this.state = this.CONNECTING;

    if (!this.accessToken) {
      return;
    }

    let sAuth = "AUTH " + this.accessToken + ";R;J;W;es;";
    this.send(sAuth);
  }

  askForChanges(): void {
    try {
      this.send("NOTIFYCHANGES 1;65535;", false);
    } catch (_) {}
  }

  public Activ(deviceId: string, bActive: boolean) {
    var activeDevices = window.sessionStorage.getItem("ActiveDevices");
    if (bActive) {
      if (activeDevices == null) {
        var activeDevices2: string[] = [];
        activeDevices2.push(deviceId);
        var activeDevices3 = JSON.stringify(activeDevices2);
        window.sessionStorage.setItem("ActiveDevices", activeDevices3);
      } else {
        var activeDevices2: string[] = JSON.parse(activeDevices);
        var index = activeDevices2.findIndex((elem) => {
          return elem == deviceId;
        });

        if (index == -1) {
          activeDevices2.push(deviceId);
          var activeDevices3 = JSON.stringify(activeDevices2);
          window.sessionStorage.setItem("ActiveDevices", activeDevices3);
        }
      }
    } else {
      if (activeDevices != null) {
        var activeDevices2: string[] = JSON.parse(activeDevices);
        var index = activeDevices2.findIndex((elem) => {
          return elem == deviceId;
        });

        if (index != -1) {
          activeDevices2.splice(index, 1);
          var activeDevices3 = JSON.stringify(activeDevices2);
          window.sessionStorage.setItem("ActiveDevices", activeDevices3);
        }
      }
    }
    let sActiv = "ACTIV " + deviceId + ";" + (bActive ? "1" : "0");
    this.send(sActiv);
  }

  public checkPing() {
    let self = this;
    self.pingConnectionTimer = setInterval(() => {
      var now: Date = new Date();
      now.setSeconds(now.getSeconds() - 90);
      if (self.recievedPong < now && self.webSocket != undefined) {
        // check if the the last received message is greater than the current time by 40 seconds
        self.webSocket.close();
        //Quan tanquem la connexio per ping, la tornem a obrir
        self.onConnect();
      }
    }, 10000); //Check every 10 seconds
  }

  public closeConnection() {
    this.retryConnection = false;
    if (this.webSocket != undefined && this.webSocket != null) {
      this.clearSessionStorage();
      this.stopRetrying(this.webSocket);
      this.webSocket.close();
    }
    this.webSocket = null;
    this.state = this.CLOSED;
    this.isRetryConnection = false;
    clearInterval(this.pingConnectionTimer);
    this.pingConnectionTimer = null;
  }

  public clearSessionStorage() {
    window.sessionStorage.removeItem("ActiveDevices");
    window.sessionStorage.removeItem("NOTIFYCHANGES");
  }

  private stopRetrying(socketInstance: Websocket | null) {
    if (!socketInstance) {
      return;
    }
    try {
      const disposer = (socketInstance as any).dispose;
      if (typeof disposer === "function") {
        disposer.call(socketInstance);
      }
    } catch (_) {}
  }
}
